export default __webpack_public_path__ + "static/media/Algeria.6f0b8b39.png";